import { Component, forwardRef, Input, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { error, log } from '../../../_helpers/log';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CheckboxComponent),
    },
  ],
})
export class CheckboxComponent implements OnInit, ControlValueAccessor {
  @Input()
  label?: string = '';

  @Input()
  form: FormGroup;

  @Input()
  formControlName: string;

  @Input()
  disabled: boolean = false;

  @Input()
  value: string = '';

  @Input()
  checked: boolean;

  @Input()
  slot: string = 'start';

  touched: boolean = false;
  isRequired: boolean;
  errors: any[] = [];

  onChange: (_: any) => void = (_: any) => {};

  onTouched: () => void = () => {};

  updateChanges(value: string) {
    this.value = value;
    this.form.patchValue({
      [this.formControlName]: this.value,
    });

    this.onChange(this.value);
  }

  constructor() {}

  ngOnInit(): void {
    if (!this.formControlName)
      error(
        'formControlName is missing, component require providing this field pointing to form field'
      );
    if (!this.form)
      error('Form is missing, component require form to bo working!!!');
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  handleBlur() {
    this.touched = true;
  }
}
